import React from 'react';
import ReactDOM from 'react-dom';
import 'styles/styles.css';
import Root from './components/Root';
import * as serviceWorker from './serviceWorker';
import theme from 'styles/theme';
import './locales/i18n';

ReactDOM.render(
    <React.StrictMode>
        <Root theme={theme} />
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
